import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import en from '../../../../lang/en-us';
import { SubmitButton } from '../../../../lib/Button';
import { TableColumn, TableWithCollapse } from '../../../../lib/DataTable';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import { fetchInvestorDetails } from '../../../../redux-store/actions/nct';
import { RootStateType } from '../../../../redux-store/reducers';
import { LIST_PROTFOLIO_PAYLOAD } from '../../../../redux-store/types/portfolio';
import { getInvestorFunds, transactionSourceScenarioEmpty } from '../../portfolios/utils';
import { DEBT, EQUITY, LIQUID, OTHER, DATA_ERROR } from '../../../../utils/constants';
import { ConsolidateTableRowType } from '../ConsolidationFolios/types';
import NoFoliosFound from '../NoFoliosFound';
import { ActionHeader, FaqLink } from '..';
import { NFT_TRXN_TYPE_MAP } from '../../commercial/utils';
import { PanSeedCheckNew } from '../../../common/PanSeedCheckNew';
import { findDefaultBank } from '../ChangeBank';
const { dashboard } = en;

export const CorrectionFolioColumns: TableColumn[] = [
    {
        field: 'id',
        headerName: 'FOLIO',
    },
    {
        field: 'amcName',
        headerName: 'Fund House',
        width: 250,
        filterBy: true,
        filterHeader: 'Fund House',
        filterKey: 'amcName',
    },
    {
        field: 'bank',
        headerName: 'BANK NAME',
        valueGetter: ({ row }) => findDefaultBank(row)?.name || 'Not Available',
        width: 200,
    },
    {
        field: 'ifsc',
        headerName: 'IFSC',
        valueGetter: ({ row }) => findDefaultBank(row)?.ifsc || 'Not Available',
        width: 200,
    },
    {
        field: 'investorName',
        headerName: 'PRIMARY HOLDER',
        valueGetter: ({ row }) => (row?.investorName || '').toUpperCase() || 'Not Available',
        width: 100,
    },
    {
        isFilter: true,
        field: 'assetType',
        headerName: 'Category',
        filterBy: true,
        renderStaticFilters: [EQUITY, LIQUID, DEBT, OTHER],
    },
];

function CorrectionFolios(props: any) {
    const [rowData, setRowData] = useState<ConsolidateTableRowType[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const { selectedRows, setSelectedRows, tableRows, tableColumns, ...filters } =
        useTableWithCollapse<ConsolidateTableRowType[]>({
            rows: rowData,
            columns: CorrectionFolioColumns,
            loading,
        });

    useEffect(() => {
        async function callApi() {
            const payload: LIST_PROTFOLIO_PAYLOAD = {
                pan: props.pan,
                mobile: props.mobile,
                pekrn: props.pekrn,
                reqId: props.reqId,
            };
            setLoading(true);
            try {
                const { body: investorDetails = {} } = await props.fetchInvestorDetails(payload);
                const { success: correctionFolios = [] } = investorDetails;
                const correctionFoliosRowData = getInvestorFunds(correctionFolios, [
                    transactionSourceScenarioEmpty,
                ]);
                setRowData(correctionFoliosRowData);
                setLoading(false);
            } catch (err: any) {
                alert(err.message);
            }
        }
        callApi();
        return () => {};
    }, []);

    const _handleNext = () => {
        props.history.push('correction-folios-selection', { fund: selectedRows[0] });
    };

    const [callPanSeed, setCallPanSeed] = useState(false);

    const resetTrigger = () => {
        setCallPanSeed(false);
    };

    return (
        <div className="curved-bg">
            <PanSeedCheckNew
                foliosArray={selectedRows}
                callBackFn={_handleNext}
                trxnType={NFT_TRXN_TYPE_MAP.correctionOfErroneousData}
                goBack={false}
                triggerCheck={callPanSeed}
                resetTrigger={resetTrigger}
            />
            <ActionHeader header={dashboard.CorrectionFolios.CorrectionFoliosHeading} />
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    <h5> {dashboard.CorrectionFolios.CorrectionFoliosInfo}</h5>
                    <div
                        className="curved-table-content"
                        tabIndex={0}
                        aria-label="Correction folios list"
                    >
                        {!!tableRows.length ? (
                            <TableWithCollapse
                                rows={tableRows}
                                columns={tableColumns}
                                setSelectedRows={setSelectedRows}
                                selectedRows={selectedRows}
                                radioGroupsEnabled
                                {...filters}
                            />
                        ) : (
                            <NoFoliosFound />
                        )}
                    </div>
                    <FaqLink section={DATA_ERROR} history={props.history} />
                </div>
                <div className="curved-bg-content-inner-bottom">
                    {!!rowData.length && (
                        <div className="table-submit">
                            <SubmitButton
                                disabled={!selectedRows.length}
                                className="customBtn"
                                label={dashboard.CorrectionFolios.buttonText}
                                onClick={() => setCallPanSeed(true)}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    fetchInvestorDetails,
})(CorrectionFolios);
